export default {
    "FETCH_LAYOUTS": "FETCH_LAYOUTS"
}